<template>
  <main id="content" aria-labelledby="main-title">

    <Section background="#f9f8f6">
      <Container>
        <FadeIn class="mx-auto max-w-3xl text-center py-12 md:py-20">
          <h1 id="main-title" class="text-3xl leading-[1.2] sm:text-4xl md:text-5xl md:leading-[1.12] font-bold tracking-tight text-gray-900 lora">
            Frequently asked questions
          </h1>
          <p class="mt-6 text-lg text-gray-700">
            Answers to the questions we hear most often about speak-up, whistleblowing, and compliance: how Elker's platform works and how it fits into your organisation.
          </p>
        </FadeIn>
      </Container>
    </Section>

    <BlockFaqs v-if="faqContent" :content="faqContent" :sectionTotal="1" :sectionIndex="0" />

    <ElementBookDemoCta />

  </main>
</template>

<script setup>
const { getItems } = useCms()
const route = useRoute()

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const { data: faqItems } = await useAsyncData(
  'faq-page-items',
  () => getItems({
    collection: 'faq_item',
    params: {
      fields: ['id', 'question', 'answer'],
      limit: -1
    }
  })
)

const faqContent = computed(() => {
  const items = faqItems.value || []
  const seen = new Set()
  const unique = []
  for (const item of items) {
    const key = (item.question || '').trim().toLowerCase()
    if (!key || seen.has(key)) continue
    seen.add(key)
    unique.push({ faq_item_id: { question: item.question, answer: item.answer } })
    if (unique.length >= 40) break
  }
  return {
    title: '',
    faqs: unique
  }
})

const pageTitle = 'Frequently asked questions | Elker'
const pageDescription = "Common questions about Elker's speak-up programmes and how we handle Corporations Act, Respect@Work, and psychosocial safety obligations."

useHead(
  useSeo(
    {
      meta_title: pageTitle,
      meta_description: pageDescription,
      meta_image: null
    },
    route.fullPath
  )
)
</script>
